<template>
  <svg :width="size" :height="size" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" transform="translate(0 0.119995)"/>
    <path d="M21.3333 2.78662H10.6666C6.25463 2.78662 2.66663 6.37462 2.66663 10.7866V28.12C2.66663 28.4736 2.8071 28.8127 3.05715 29.0628C3.3072 29.3128 3.64634 29.4533 3.99996 29.4533H21.3333C25.7453 29.4533 29.3333 25.8653 29.3333 21.4533V10.7866C29.3333 6.37462 25.7453 2.78662 21.3333 2.78662ZM22.6666 17.4533H17.3333V22.7866H14.6666V17.4533H9.33329V14.7866H14.6666V9.45329H17.3333V14.7866H22.6666V17.4533Z" fill="currentColor"/>
    <defs>
    <linearGradient id="paint0_linear_795_2879" x1="2.66663" y1="16.12" x2="29.3333" y2="16.12" gradientUnits="userSpaceOnUse">
    <stop stop-color="currentColor"/>
    <stop offset="1" stop-color="currentColor"/>
    </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    size: { type: String }
  }
}
</script>